import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { LanguageProps } from '../../interfaces/components';

const Language = ({ language, selectedLanguage, onClick }: LanguageProps) => {
  return (
    <Box
      h="46px"
      w="120px"
      onClick={() => onClick(language)}
      border={selectedLanguage === language ? '1px solid #C29F6B' : '1px solid #455255'}
      color={selectedLanguage === language ? 'white' : '#455255'}
      bg={selectedLanguage === language ? '#C29F6B' : 'white'}
      display="flex"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      _hover={{ color: 'white', bg: '#C29F6B', border: '1px solid #C29F6B' }}
    >
      <Text fontWeight="500" fontSize={['12px', '12px', '12px', '14px', '14px']} fontFamily="JosefinSans">
        {language}
      </Text>
    </Box>
  );
};

export default Language;
